import { motion } from 'framer-motion';
import { libraryImages } from '../assets/imageLibrary';

// Original assets library — bilingual "little nature explorers" wall
// expresses our pedagogical excellence and identity.
const images = {
  whyUs: libraryImages.natureExplorersWall,
};

const features = [
  'تشخيص احترافي قائم على الأدلة',
  'حلول تطوير مصممة حسب احتياج المنشأة',
  'دعم متخصص للاستعداد للاعتمادات الوطنية والدولية',
];

const WhyUs = () => {
  return (
    <section data-testid="why-us-section" className="py-16 bg-[#F7F5F2]" dir="rtl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-8 lg:gap-10 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={images.whyUs}
            alt="بيئة تعليمية"
            className="w-full h-[280px] sm:h-[320px] md:h-[420px] object-cover rounded-[20px] sm:rounded-[28px] shadow-lg"
          />
        </motion.div>

        {/* Content */}
        <motion.div 
          className="text-right"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block px-4 py-2 rounded-full border border-[#D8D2C8] text-[#5D6E55] text-xs sm:text-sm mb-4 sm:mb-5">
            لماذا آفاق الطفولة؟
          </span>
          
          <h2
            className="font-['Noto_Kufi_Arabic'] font-bold text-[#B08A5A] text-3xl sm:text-4xl md:text-5xl lg:text-[54px] leading-[1.55] sm:leading-[1.5] md:leading-[1.45] mb-4 sm:mb-6 max-w-[15ch]"
            style={{ letterSpacing: '0.005em', wordSpacing: '0.05em' }}
          >
            نقود رحلة التطوير... ونمهد طريق الاعتماد
          </h2>
          
          <p className="text-[#6B7565] leading-8 sm:leading-9 text-base sm:text-lg mb-6 sm:mb-8">
            نقدم حلولاً استشارية متخصصة تجمع بين الخبرة المحلية والممارسات العالمية، لتمكين مؤسسات الطفولة المبكرة من تطوير الأداء، وتحسين جودة الممارسات، والاستعداد للاعتمادات الوطنية والدولية.
          </p>

          <ul className="space-y-3 sm:space-y-4 text-[#1F3D2B] text-base sm:text-lg">
            {features.map((feature, index) => (
              <motion.li 
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="flex items-center gap-3"
              >
                <span className="text-[#4A641F]">✔</span>
                {feature}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyUs;
